// Thin wrappers around /api/admin/alert-config used by the
// AlertPreferences page.
import { get, post, putGeneral } from '../index';

export const getAlertConfig  = () => get('/api/admin/alert-config');
export const saveAlertConfig = (body) => putGeneral('/api/admin/alert-config', body);
export const testAlertConfig = () => post('/api/admin/alert-config/test', {}, false);
